
 <template >
  <div class="document-block">
    <template>
      <ob-collapse :type="1" :expand.sync="IsExpand" :disabled="false">
        <template slot="leftheader">
          <h4 class="folder-headers">{{FolderHeaderHeading}}</h4>
        </template>
        <template slot="body">
          <ob-spinner v-if="IsLoading"></ob-spinner>
          <div class="document-list" v-else-if="docList.length > 0">
            <ob-document-list-ess
              :groupId="GroupId"
              :documentList="l"
              @onDocumentUpdate="updateDocument(index, ...arguments)"
              :fileUploadUrl="fileUploadUrl"
              :key="`documentlist-${index}`"
              v-for="(l, index) in docList"
              :BenefitsStatus="BenefitsStatus"
              :BenefitsEffectiveFrom="BenefitsEffectiveFrom"
              :BenefitsList="BenefitsList"
              @AddorUpdate="AddorUpdateDoc"
              :From="From"
            ></ob-document-list-ess>
          </div>
          <div class="document-list" v-else>
            <p class="no-docs">No Documents Available</p>
          </div>
        </template>
      </ob-collapse>
    </template>
  </div>
</template>
<script>
export default {
  props: ["GroupId", "FolderHeaderHeading", "BenefitsStatus", "BenefitsEffectiveFrom", "BenefitsList", "From"],
  data() {
    return {
       isRequestSent: '',
      IsExpand: false,
      IsLoading: true,
      docList: []
    };
  },
  computed: {
    fileUploadUrl() {
      return `/OnBoard/UpdateDocumentByGroup?consultantId=${this.loggedInUserObj.consultantId}&jobId=${loggedInUserObj.empId}&orgId=${loggedInUserObj.orgId}`;
    }
  },
  watch: {
    IsExpand(val) {
      if (val === true) {
        // On Expand
        this.getDocumentsByGroupId(this.GroupId);
      }
    }
  },

 created(){
      events.listen('personnelfile', (grpId) => {
           this.isRequestSent = grpId
          this.getDocumentsByGroupId(this.GroupId)
      })
      
    },
  methods: {
    AddorUpdateDoc(groupId){
      this.getDocumentsByGroupId(groupId);
    },
    getDocumentsByGroupId(groupId) {
      
      if((this.isRequestSent != '' && this.isRequestSent == this.GroupId) || (this.isRequestSent == 'BeneficiaryDocuments' && this.GroupId == 'IDProof')){
          this.IsLoading = true;
      }else if(this.isRequestSent != '' && this.isRequestSent != this.GroupId){
          this.IsLoading = false;
      }else{
          this.IsLoading = true;
      }

      ajax.get(
        `/OnBoard/${this.loggedInUserObj.consultantId}/{}/GetDocumentList?group=${groupId}&orgId=${this.loggedInUserObj.orgId}&isESS=true`,
        {},
        res => {
          if (res.data.State == true) {
            this.docList = res.data.ListOfDocuments;

            this.docList.forEach(d => {
              d.CanESign = true;
              this.$set(d, "jobid", this.$route.query.jobId);
            });

            this.IsLoading = false;
          } else {
            this.ESSEnableDisable(res);
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        }
      );
    },
    updateDocument(index, document) {
      Vue.set(this.docList, index, document);
    }
  }
};
</script>
<style lang="scss" scoped="">
.folder-headers {
  font-weight: 600;
  color: #143361;
}
.no-docs {
  text-align: center;
  padding: 20px;
  font-weight: 600;
  font-size: 13px;
  border-top: 1px dashed #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/CustomCollapse.vue